<template>
  <div class="form-group">
    <label :for="id" class="control-label">{{ goalTypeLabel }} Resources | {{ accessPointToLabelMap[apLevel] }}</label>
    <div class="input-group">
      <input
        :id="id"
        type="text"
        v-model="uuidToAdd"
        @keypress.enter="addResource"
        class="form-control"
        placeholder="Paste resource UUID">
      <span class="input-group-btn">
        <button
          class="btn btn-default"
          type="button"
          @click="addResource"
          :disabled="!uuidToAdd">Add</button>
      </span>
    </div>
    <draggable
      tag="ul"
      :id="`${id}-resources-list`"
      :list="selectedInternal"
      @change="sequenceChanged"
      handle=".draggable-handle"
      class="list-group">
      <li
        class="list-group-item"
        v-for="(r, index) of selectedInternal"
        :key="r">
        <span class="draggable-handle">
          <a :href="detailURL(r)" target="_blank">{{ resourcesMap[r] && resourcesMap[r].title || r }}</a>
          <span
            class="badge"
            v-if="resourcesMap[r] && resourcesMap[r].language && resourcesMap[r].language != 'english'">
            {{ resourcesMap[r].language | capitalize }}
          </span>
        </span>
        <a
          class="remove text-danger"
          role="button"
          :aria-label="`Remove resource ${resourcesMap[r] && resourcesMap[r].title || r}`"
          @click="remove(index)">
          <i class="fa fa-times"/>
        </a>
      </li>
    </draggable>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import { pathwaysUrls } from '@/links'
import { AccessPointsUtil } from '@/components/goals/common/access_points'

export default {
  name: 'ResourcesSelect',
  components: { draggable },
  props: {
    id: {
      type: String,
      required: true
    },
    selected: {
      type: Array,
      default: () => []
    },
    resourcesMap: {
      type: Object,
      default: () => {}
    },
    apLevel: {
      type: String,
      required: true
    },
    objLevel: {
      type: String,
      required: false
    },
    goalType: {
      type: String,
      default: 'annual_target'
    }
  },
  data() {
    return {
      uuidToAdd: '',
      selectedInternal: this.selected || [],
      accessPointToLabelMap: AccessPointsUtil.labelsMap,
      goalTypeLabel: this.goalType !== 'annual_target' ? `${this.objLevel} Quarter` : 'Annual Target'
    }
  },
  methods: {
    addResource() {
      if (!this.uuidToAdd || this.selected && this.selected.includes(this.uuidToAdd)) {
        this.uuidToAdd = ''
        return
      }
      this.selectedInternal = [...this.selectedInternal, this.uuidToAdd]
      this.$emit('update:selected', this.selectedInternal, this.getLanguages())
      this.$emit('add', this.uuidToAdd, this.getLanguages())
      this.uuidToAdd = ''
    },
    detailURL(id) {
      return pathwaysUrls.resourceDetail(id)
    },
    remove(i) {
      this.selectedInternal.splice(i, 1)
      this.$emit('update:selected', [...this.selectedInternal], this.getLanguages())
    },
    sequenceChanged(evt) {
      if (evt.moved) {
        this.$emit('update:selected', [...this.selectedInternal])
      }
    },
    getLanguages() {
      const languages = [];
      for (const [key, value] of Object.entries(this.resourcesMap)) {
        if (this.selectedInternal.includes(key) && value['language'] !== '') {
          languages.push(value['language'])
        }
      }
      const uniqueLangs = [...new Set(languages)];
      return uniqueLangs
    }
  },
  watch: {
    selected(newValue) {
      this.selectedInternal = newValue || []
    }
  }
}
</script>

<style lang="less" scoped>
.input-group {
  margin-bottom: 1em;
}
.list-group-item {
  display: flex;
  span {
    flex: 1 1 auto;
  }
  .remove {
    flex: 0 0 auto;
  }
}
.badge {
  float: right;
  margin-right: 10px;
  margin-top: 2px;
}
</style>
